import { createContext, useContext } from "react";

import { useStore } from "zustand";

import type { createTimelineStore, TimelineStore } from "./timeline";
import type { createTimelineDataStore, TimelineDataStore } from "./timeline-data";

// Timeline UI Store Context
const TimelineStoreContext = createContext<ReturnType<typeof createTimelineStore> | null>(null);

export const TimelineStoreProvider = TimelineStoreContext.Provider;

export function useTimelineStore<T>(selector: (state: TimelineStore) => T): T {
  const store = useContext(TimelineStoreContext);
  if (!store) {
    throw new Error("useTimelineStore must be used within TimelineStoreProvider");
  }
  return useStore(store, selector);
}

// Timeline Data Store Context
const TimelineDataStoreContext = createContext<ReturnType<typeof createTimelineDataStore> | null>(null);

export const TimelineDataStoreProvider = TimelineDataStoreContext.Provider;

export function useTimelineDataStore<T>(selector: (state: TimelineDataStore) => T): T {
  const store = useContext(TimelineDataStoreContext);
  if (!store) {
    throw new Error("useTimelineDataStore must be used within TimelineDataStoreProvider");
  }
  return useStore(store, selector);
}
